module.exports = __webpack_public_path__ + "img/cannot-reset-roster.1f681195.png";